module.exports = __webpack_public_path__ + "./Jane2_4abee91e10837930f04ffb932a197df8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Jane2.png
// module id = 557
// module chunks = 0